<div class="modal-header">
    <ion-grid class="ion-no-padding">
        <ion-row class="ion-no-padding">
            <ion-col size="10"
                     class="ion-no-padding">
                {{ 'CUSTOM_IMPRESSUM' | translate}}
            </ion-col>
            <ion-col size="2"
                     class="ion-no-padding ion-text-right">
                <a (click)="close()">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-close.svg"
                              class="icon fill-dark">
                    </svg-icon>
                </a>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>

<ng-container *ngIf="loading">
    <div class="content-centered-column loading">
        <div class="content-centered-row">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</ng-container>


<div *ngIf="!loading"
     class="content-centered-column">

    <div class="fr-view"
         [innerHTML]="eventSetting.translate(userLang).imprint | linkify | securedImages | safe:'html'">
    </div>
</div>